import { Column } from "@ant-design/plots";
import { Row, Spin, Col, Tooltip } from "antd";
import { SalesOverview } from "src/modules/sales/types/types";

import AIIMG from "src/assets/img/ai.gif";

const DemoDefaultTooltip = ({
  overview,
  loading,
}: {
  overview: SalesOverview;
  loading: boolean;
}) => {
  const config = {
    data: overview.day_by_sales,
    xField: "day",
    yField: "sale",
    autoFit: true,
    yAxis: {
      min: 0,
    },
    tooltip: {
      showMarkers: false,
    },
    onReady: (chart: any) => {
      try {
        const positiveSales = overview.day_by_sales.filter(
          (item) => item.sale > 0
        );
        if (positiveSales.length > 0) {
          const tooltipItem =
            positiveSales[Math.floor(Math.random() * positiveSales.length)];
          chart.chart.on("afterrender", () => {
            chart.chart.emit("tooltip:show", {
              data: {
                data: tooltipItem,
              },
            });
          });
        }
      } catch (e) {
        console.error("Tooltip show failed", e);
      }
    },
  };

  return loading ? (
    <Row>
      <Col span={24} style={{ textAlign: "center", paddingTop: "10%" }}>
        <Spin size="large" />
      </Col>
    </Row>
  ) : (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "auto",
      }}
    >
      <img
        src={AIIMG}
        alt="ai"
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          width: 30,
          height: 30,
          zIndex: 10,
        }}
      />

      <div style={{ paddingTop: 10, width: "100%", height: "80%" }}>
        <Column scale={["day", "sale"]} {...config} />
      </div>
    </div>
  );
};

export default DemoDefaultTooltip;
